import { colors } from '@fs/zion-ui'

export const tabGenderColorMap = {
  MALE: 'blue',
  FEMALE: 'red',
  // We use blue for unknown since it's the default color for interactive items.
  UNKNOWN: 'blue',
} as const

export const stripeColorMap = {
  MALE: colors.blue80,
  FEMALE: colors.red80,
  UNKNOWN: colors.gray80,
}
